import axios, { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import { environment } from '../../environment';
import { KlaviyoMetricsFormViewPayload, KlaviyoFormKeys, KlaviyoMetricsFormSubmitPayload, HoneyloveSite } from '../../models/klaviyo/SubscribeToKlaviyo';
import { isMobileState } from '../../recoil/selectors';
import { useRecoilValue } from 'recoil';
import { environmentContextState } from '../../recoil/atoms';

export const useKlaviyoMetrics = (
  klaviyoFormKeys: KlaviyoFormKeys,
): { klaviyoFormViewed: () => Promise<AxiosResponse<void>>; klaviyoFormSubmitted: (email: string) => Promise<AxiosResponse<void>> } => {
  const isMobile = useRecoilValue(isMobileState);
  const environmentContext = useRecoilValue(environmentContextState);
  const siteDomain: HoneyloveSite = environmentContext.permanentDomain === 'honey-buns-shapewear.myshopify.com' ? 'www.honeylove.com' : 'dev.honeylove.com';

  const klaviyoFormViewed = useCallback(async () => {
    const payload: KlaviyoMetricsFormViewPayload = {
      metricGroup: 'signup-forms',
      events: [
        {
          company_id: klaviyoFormKeys.companyId,
          device_type: isMobile ? 'MOBILE' : 'DESKTOP',
          metric: 'loadedEmbed',
          first_referrer: document.referrer,
          form_id: klaviyoFormKeys.formId,
          form_type: 'EMBED',
          form_version_id: klaviyoFormKeys.versionId,
          hostname: siteDomain,
          referrer: document.referrer,
          href: window.location.href,
          page_url: window.location.href,
        },
      ],
    };
    return axios.post<void>(environment.klaviyoMetricsUrl, payload);
  }, [isMobile, klaviyoFormKeys, siteDomain]);

  const klaviyoFormSubmitted = useCallback(
    async (email: string) => {
      const payload: KlaviyoMetricsFormSubmitPayload = {
        metricGroup: 'signup-forms',
        events: [
          {
            submittedFields: {
              $source: klaviyoFormKeys.formName,
              $email: email,
              $consent_method: 'Klaviyo Form',
              $consent_form_id: klaviyoFormKeys.formId,
              $consent_form_version: klaviyoFormKeys.versionId,
              services: '{"shopify":{"source":"form"}}',
            },
            action_type: 'Submit Form',
            metric: 'submitModal',
            form_id: klaviyoFormKeys.formId,
            form_version_id: klaviyoFormKeys.versionId,
            company_id: klaviyoFormKeys.companyId,
            form_type: 'EMBED',
            device_type: isMobile ? 'MOBILE' : 'DESKTOP',
            hostname: siteDomain,
            href: window.location.href,
            page_url: window.location.href,
            first_referrer: document.referrer,
            referrer: document.referrer,
          },
        ],
      };
      return axios.post<void>(environment.klaviyoMetricsUrl, payload);
    },
    [isMobile, klaviyoFormKeys, siteDomain],
  );

  return { klaviyoFormViewed, klaviyoFormSubmitted };
};
